<template lang="pug">
component(
  :is='isMobile ? "pdf-mobile" : "pdf"'
  @document-loaded='onDocumentLoaded'
  @proxy-pages='onProxyPages'
  @selected-page='onSelectedPage'
  @size='onSize'
  @version='onVersion'
  v-bind='$props'
  v-on='$listeners'
)
  template(v-for='(_, slot) in $scopedSlots' v-slot:[slot]='scope')
    slot(:name='slot' v-bind='scope')
</template>

<script>
import Pdf from './Pdf.vue';
import PdfMobile from './PdfMobile.vue';

export default {
  name: 'PdfRenderer',
  components: {
    Pdf,
    PdfMobile,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    showEnvelopeOptions: {
      type: Boolean,
      default: false,
    },
    showExpandOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile() {
      return this.$root.isMobile;
    },
  },
  methods: {
    onDocumentLoaded(value) {
      this.$emit('document-loaded', value);
    },
    onProxyPages(pages) {
      this.$emit('proxy-pages', pages);
    },
    onSelectedPage(page) {
      this.$emit('selected-page', page);
    },
    onVersion(version) {
      this.$emit('version', version);
    },
    onSize(size) {
      this.$emit('size', size);
    },
  },
};
</script>
